import React from 'react'
import actions from 'redux/actions'
import { useAbValues, useCallback } from 'sb-hooks'
import { ce2, constants, snowplow } from 'common/helpers'
import type { Events } from 'common/helpers/analytics/snowplow/config'

import { Button } from 'components/_new/controls'
import type { ButtonProps } from 'components/_new/controls'

import { openSkipAMonthModal } from 'compositions/modals/skipAMonth'

import messages from './messages'


type SkipAMonthButtonProps = Partial<Pick<ButtonProps, 'className' | 'size' | 'title' | 'color' | 'fullWidth' | 'dataTestId' | 'onClick'>> & {
  placement: Events['Skip month click']['placement']
}

const SkipAMonthButton: React.FunctionComponent<SkipAMonthButtonProps> = (props) => {
  const {
    className, fullWidth, placement, onClick,
    size = 'md',
    color = 'brand',
    title = messages.title,
    dataTestId = constants.testIds.profile.orderStatusButtons.skip,
  } = props

  const isNewCancelFlowEnabled = useAbValues(constants.abTests.unsubscriptionFlow) === 'b'

  const handleClick = useCallback((event) => {
    if (typeof onClick === 'function') {
      onClick(event)
    }

    ce2.set(1, constants.analyticsEvents.skipMonthClick)
    snowplow.track('Skip month click', { placement })

    if (isNewCancelFlowEnabled) {
      snowplow.track('UF skip button click')

      openSkipAMonthModal({
        isUnsubscribeFlow: false,
      })
    }
    else {
      actions.models.modals.open(constants.modals.SkipAMonth)
    }
  }, [ onClick, placement, isNewCancelFlowEnabled ])

  return (
    <Button
      className={className}
      size={size}
      title={title}
      color={color}
      fullWidth={fullWidth}
      dataTestId={dataTestId}
      onClick={handleClick}
    />
  )
}


export default SkipAMonthButton
